
import './App.css';
import Weather from './Weather';
import Footer from './footer';


function App() {

  return (
    <div className="App">
      <header className="App-header">
        <Weather/>
        <Footer/>
      </header>
    </div>
  );
}

export default App;
